<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isWechat: true, // 是否为微信环境（true：是；false：否）
      wx: {
        wxAppId: "wx5fa1672f43e8c5ef", // 微信公众号 ID
        wxSecret: "", // 微信公众号 密钥
        code: "", // 授权获取的 code
        openid: "", // 授权获取的 openid
        unionid: "" // 授权获取的用户唯一标识 unionid
      }
    };
  },
  methods: {
    getOpenId() {
      let that = this;
      that.http
        .post("response/Member/getWechatOpenID", {})
        .then(res => {
          if (res.data.result == "SUCCESS") {
            let data = res.data.data;
            if (data.openid == null || data.openid == null) {
              window.location.href = "https://api.databnu.com/WechatLogin.php";
            } else {
            }
            window.localStorage.setItem(
              "cloudOpenId",
              JSON.stringify(res.data.data)
            );
            that.$cookies.set("items", JSON.stringify(res.data.data));
          } else if (res.data.result == "ERROR") {
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
  },
  created() {
    // 检测是浏览器端还是微信端
    let ua = navigator.userAgent.toLowerCase();
    if (String(ua.match(/MicroMessenger/i)) === "micromessenger") {
      this.isWechat = true;
    } else {
      this.isWechat = false;
    }
  },
  mounted() {
    console.log(this.isWechat);
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue